<div class="bg-white rounded-tl-lg rounded-tr-lg text-dark-grey overflow-hidden">
  <app-modal-header
    [title]="title()"
    iconPath="assets/icons/identification-card.svg"
  />

  <div class="p-6">
    <form class="mb-10">
      <app-input
        type="number"
        label="Gewicht"
        [control]="form.controls.weight"
      />

      <app-input
        type="date"
        label="Datum"
        [control]="form.controls.date"
      />
    </form>

    <div class="flex flex-col gap-2">
      <app-button
        text="Änderungen speichern"
        [isLoading]="requestState() === RequestStateEnum.PENDING"
        [disabled]="form.invalid || !form.dirty"
        [fullWidth]="true"
        (clicked)="onClick()"
      />

      @if (showDeleteButton()) {
        <div class="flex justify-center items-center text-gray-600">
          <p>oder</p>
        </div>

        <app-button
          text="Eintrag löschen"
          variant="alert"
          [isLoading]="requestState() === RequestStateEnum.PENDING"
          [fullWidth]="true"
          (clicked)="deleteItem()"
        />
      }
    </div>
  </div>
</div>
